export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/browser-server.06b54be5.worker.js");
}
